@if (isReady) {
  @if (orders?.length) {
    <table class="table-depot" @onlyEnter aria-describedby="execDate">
      <tbody>
        <tr>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="assetName"
              label="mydepot.depotoverview.executed-orders.labels.assetName"
              direction="after"
              (click)="sortBy('assetName')"
            /><br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="isin"
              label="mydepot.depotoverview.executed-orders.labels.isin"
              direction="after"
              (click)="sortBy('isin')"
            />
          </th>
          <th>
            {{ 'mydepot.depotoverview.executed-orders.labels.quantity' | transloco }}<br />
            {{ 'mydepot.depotoverview.executed-orders.labels.status' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.executed-orders.labels.execType' | transloco }}<br />
            {{ 'mydepot.depotoverview.executed-orders.labels.execPrice' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.executed-orders.labels.execDate' | transloco }}<br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="execDate"
              label="mydepot.depotoverview.executed-orders.labels.execTime"
              direction="before"
              (click)="sortBy('execDate')"
            />
          </th>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="direction"
              label="mydepot.depotoverview.executed-orders.labels.direction"
              direction="before"
              (click)="sortBy('direction')"
            /><br />
            {{ 'mydepot.depotoverview.executed-orders.labels.value' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.executed-orders.labels.surcharge' | transloco }}<br />
            {{ 'mydepot.depotoverview.executed-orders.labels.provision' | transloco }}
          </th>
          @if (actionsEnabled) {
            <th></th>
          }
        </tr>
        @for (order of orders | slice: 0 : pageSize; track order.id) {
          <tr app-executed-order-item [order]="order" [actionsEnabled]="actionsEnabled"></tr>
        }
      </tbody>
    </table>
    <div class="row mt-2 mb-4">
      <div class="col-12 text-right">
        <a [class.hidden]="!hasNext" (click)="showMore()" class="link-secondary cursor-pointer">
          {{ 'mydepot.depotoverview.executed-orders.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
        </a>
      </div>
    </div>
  } @else {
    <p class="mt-3 mb-0">
      {{ 'mydepot.depotoverview.executed-orders.empty' | transloco }}
    </p>
  }
  <div class="justify-content-center mt-4 pt-2 border-top text-size-medium">
    <div class="d-flex flex-grow">
      <div class="btn-icon disabled mr-2" title="Abrechnung noch nicht verfügbar">
        <svg class="icon icon-24 icon-inactive">
          <use xlink:href="/assets/img/svgs/svgset.svg#preview-redesign" />
        </svg>
      </div>
      <div [innerHTML]="'mydepot.depotoverview.executed-orders.hint' | transloco"></div>
    </div>
  </div>
}

<ng-template #empty>
  <p class="mt-3 mb-0">
    {{ 'mydepot.depotoverview.executed-orders.empty' | transloco }}
  </p>
</ng-template>
